import type { Immutable } from "immer";
import React from "react";
import { getGlobalSpacingClasses } from "tsi-common-react/src/components/_spacing/globalSpacing";

import type { WarrantyBlock as WarrantyBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { richHTML } from "../../utils/html";

import styles from "./index.module.scss";

export const WarrantyBlock = (
    block: Immutable<{ value: WarrantyBlockValue }>,
): React.JSX.Element => (
    <section
        className={concatClassNames([
            styles.warrantyBlock,
            getGlobalSpacingClasses(block.value.spacing),
        ])}
    >
        <div className="main-container">
            {block.value.images?.[0] ? (
                <div
                    className={concatClassNames([
                        styles.warrantyBlockImageContainer,
                        "warranty-block__image-container",
                        "warranty-block__image-container--left",
                    ])}
                >
                    <img
                        src={block.value.images[0].url}
                        alt={block.value.images[0].title}
                        className={styles.warrantyBlockImage}
                        loading="lazy"
                        decoding="async"
                    />
                </div>
            ) : null}
            <div
                className={concatClassNames([
                    styles.warrantyBlockInfo,
                    "warranty-block__info",
                ])}
            >
                <div className={styles.warrantyBlockTitle}>
                    {block.value.title}
                </div>
                <div className={styles.warrantyBlockSubTitle}>
                    {block.value.subtitle}
                </div>
                <div
                    className={concatClassNames([
                        styles.warrantyBlockCopy,
                        "warranty-block__copy",
                    ])}
                    dangerouslySetInnerHTML={richHTML(block.value.paragraph)}
                />
                <a
                    href={block.value.link?.url ?? ""}
                    className={concatClassNames([
                        styles.warrantyBlockLink,
                        "warranty-block__link",
                    ])}
                >
                    Learn More
                </a>
            </div>
            {block.value.images?.[1] ? (
                <div
                    className={concatClassNames([
                        styles.warrantyBlockImageContainer,
                        styles.warrantyBlockImageContainerRight,
                        "warranty-block__image-container",
                        "warranty-block__image-container--right",
                    ])}
                >
                    <img
                        src={block.value.images[1].url}
                        alt={block.value.images[1].title}
                        className={styles.warrantyBlockImage}
                        loading="lazy"
                        decoding="async"
                    />
                </div>
            ) : null}
        </div>
    </section>
);
